import * as Yup from 'yup';
import { PersonType } from 'src/utils/constants/clients';

export default Yup.object().shape({
  industry: Yup.string().required('SCHEMA_ERRORS.INDUSTRY_REQUIRED'),
  birthDate: Yup.date()
    .typeError('SCHEMA_ERRORS.CLIENT_DETAIL_FORM.CONSTITUTION_DATE_REQUIRED')
    .required('SCHEMA_ERRORS.CLIENT_DETAIL_FORM.CONSTITUTION_DATE_REQUIRED'),
  rfc: Yup.string().when('personType', {
    is: PersonType.PHYSICAL,
    then: schema =>
      schema
        .matches(
          /^([A-ZÑ&]{4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/,
          'SCHEMA_ERRORS.RFC_FORMAT_INVALID'
        )
        .required('SCHEMA_ERRORS.RFC_REQUIRED'),
    otherwise: schema =>
      schema
        .matches(
          /^([A-ZÑ&]{3}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/,
          'SCHEMA_ERRORS.RFC_FORMAT_INVALID'
        )
        .required('SCHEMA_ERRORS.RFC_REQUIRED')
  }),
  deedNumber: Yup.string(),
  notaryName: Yup.string(),
  notaryPracticeNumber: Yup.string(),
  notaryPracticeCity: Yup.string(),
  registryRegistrationNumber: Yup.string(),
  yearsOperating: Yup.number().min(
    0,
    'SCHEMA_ERRORS.YEARS_OPERATING_CANNOT_BE_NEGATIVE'
  ),
  monthlyIncome: Yup.number(),
  isDoctorWithTitle: Yup.boolean()
});
